<app-page-header>
  <div class="documents-header">
    <!-- Left: Page title -->
    <div class="documents-header__left">
      <div class="documents-header__icon">
        <i class="pi pi-folder-open"></i>
      </div>

      <div class="documents-header__title">
        <h3>
          {{
            isUserRole === 1 || isUserRole === 2
              ? "All Documents"
              : "My Documents"
          }}
        </h3>

        <!-- <span class="documents-header__subtitle">
        Manage and organize your documents
      </span> -->
      </div>
    </div>

    <!-- Right: Actions -->
    <div class="documents-header__actions">
      <!-- Search -->
      <!-- <div class="documents-search">
    <i class="pi pi-search"></i>

    <input type="text" [(ngModel)]="search" (keyup)="searchSubject.next($event)" placeholder="Search documents..."
      aria-label="Search documents" />

      <button *ngIf="search" type="button" class="documents-search__clear"
        (click)="search = ''; searchSubject.next($event)" aria-label="Clear search">
        <i class="pi pi-times"></i>
      </button>
    </div> -->

      <!-- Add document -->
      @if (canAddDocuments) {
      <button
        type="button"
        class="add-document-btn"
        (click)="createNewDocument()"
      >
        <i class="pi pi-plus"></i>
        <span>Add Folder</span>
      </button>
      }
    </div>
  </div>
</app-page-header>

<!-- <div class="row">
<div id="library-card-list">
  <div class="row row-cols-6">
    <ng-container *ngIf="elibraryList.length==0 else libraryListData">
      <p><span>No records found</span></p>
    </ng-container>
    <ng-template #libraryListData>
      <div class="notification-list">
        <ng-container  *ngFor="let group of elibraryList">
          <div class="card" routerLinkActive="active">
            <div class="card-body" [routerLink]="['/elibraryandcourse/e-library',group.group_id]">
              <div class="row">
                <div class="col-2">
                  <img [src]="profileUrl+group.group_icon" *ngIf="group.group_icon"/>
                  <empty-uname [userName]="group.full_name" [liProfile]="true" *ngIf="!group.group_icon"></empty-uname>
                </div>
                <div class="col-10 offset-0">
                  <label [title]="group.full_name">{{(group.full_name.length > 20 ) ?  (group.full_name | slice:0:20) +'...' : group.full_name}}</label>
                </div>
                <span *ngIf="isUserRole===1" class="icon position-absolute top-0 end-0 me-3" (click)="editLibrary()"><i class="fa-solid fa-pencil"></i></span>
              </div>
            </div>
          </div>

        </ng-container>
      </div>
    </ng-template>


  </div>
</div>
</div> -->
<!-- Mobile overlay -->
@if (isMobileView && isSidebarOpen) {
<div class="sidebar-overlay" (click)="onSidebarOverlayClick()"></div>
}

<div class="documents-layout">
  <!-- ================= LEFT LIBRARY SIDEBAR ================= -->
  <aside
    class="library-sidebar"
    [ngClass]="{
      'library-sidebar--hidden': viewLibraryList,
      'library-sidebar--open': isSidebarOpen
    }"
  >
    <!-- Mobile Header -->
    @if (isMobileView) {
    <div class="library-sidebar__mobile-header">
      <div>
        <span class="library-sidebar__mobile-title">Documents</span>
        <span class="library-sidebar__mobile-subtitle">
          Your document libraries
        </span>
      </div>
      <button
        type="button"
        class="sidebar-close-btn"
        (click)="closeSidebar()"
        aria-label="Close sidebar"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    }

    <!-- Sidebar Header -->
    <div class="library-sidebar__header">
      <div class="library-sidebar__heading">
        <div class="library-sidebar__icon">
          <i class="pi pi-folder"></i>
        </div>

        <div>
          <h4>Document Folders</h4>
          <span>Document collections</span>
        </div>
      </div>

      @if (showSearchSec) {
      <button
        type="button"
        class="sidebar-search-btn"
        (click)="showSearchBox('open')"
        title="Search libraries"
      >
        <i class="pi pi-search"></i>
      </button>
      }
    </div>

    <!-- ================= SEARCH ================= -->

    @if (!showSearchSec) {
    <div class="library-search">
      <div class="library-search__input">
        <i class="pi pi-search"></i>
        <input
          type="text"
          inputFocus
          [(ngModel)]="search"
          (keyup)="searchInList.next($event)"
          placeholder="Search libraries..."
          aria-label="Search libraries"
        />
        @if (search) {
        <button
          type="button"
          class="library-search__clear"
          (click)="search = ''; searchInList.next($event)"
          aria-label="Clear search"
        >
          <i class="pi pi-times"></i>
        </button>
        }
      </div>
      <button
        type="button"
        class="library-search__close"
        (click)="showSearchBox('close')"
        aria-label="Close search"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    }

    <!-- ================= SORT ================= -->

    @if (showSearchSec) {
    <div class="library-toolbar">
      <div class="library-sort">
        <i class="pi pi-sort-alpha-down"></i>
        <select
          [(ngModel)]="sortBy"
          (change)="getElibrary(0)"
          aria-label="Sort libraries"
        >
          <option value="title">Sort A to Z</option>
          <option value="time">Sort by Recent</option>
        </select>
        <i class="pi pi-chevron-down"></i>
      </div>
      <span class="library-count">
        {{ elibraryList?.length || 0 }}
      </span>
    </div>
    }

    <!-- ================= LIBRARY LIST ================= -->

    <div
      class="library-list"
      appInfiniteScroll
      infinite-scroll
      [infiniteScrollDistance]="modalScrollDistance"
      [infiniteScrollThrottle]="modalScrollThrottle"
      [scrollWindow]="false"
      (scrolled)="fetchElibraryList()"
      (reachedBottom)="onScrollDown()"
    >
      @if (elibraryList.length > 0) {
      <ul class="library-list__items">
        @for (group of elibraryList; track group; let ind = $index) {
        <li
          routerLinkActive="active"
          [ngClass]="{
            'library-item--inactive': group.group_active === false
          }"
          class="library-item"
        >
          <div class="library-item__content">
            <!-- Folder Icon -->
            <div class="library-item__icon">
              <i class="pi pi-folder folder-closed"></i>
              <i class="pi pi-folder-open folder-open"></i>
            </div>
            <!-- Library Details -->
            <div
              class="library-item__details"
              [routerLink]="['/elibraryandcourse/e-library', group.group_id]"
              (click)="closeSidebar()"
            >
              <div class="library-item__name" [title]="group.full_name">
                {{ group.full_name }}
              </div>
              <!-- <div class="library-item__meta">
                    Document Library
                  </div> -->
            </div>
            <!-- Delete -->
            @if (isUserRole === 1 || isUserRole === 2) {
            <button
              type="button"
              class="library-item__delete"
              (click)="removeGroupDetail(group); $event.stopPropagation()"
              title="Delete library"
              aria-label="Delete library"
            >
              <i class="pi pi-trash"></i>
            </button>
            }
          </div>
        </li>
        }
      </ul>
      }

      <!-- Empty library -->
      @if (elibraryList.length === 0) {
      <div class="library-empty">
        <div class="library-empty__icon">
          <i class="pi pi-folder-open"></i>
        </div>
        <strong>No libraries found</strong>
        <span> Create a library to organize your documents. </span>
      </div>
      }

      <pagination-loader [showFetchLoader]="showPaginateSpinner">
      </pagination-loader>
    </div>
  </aside>

  <!-- ================= MAIN CONTENT ================= -->

  <main
    class="documents-content"
    [ngClass]="{
      'documents-content--expanded': viewLibraryList
    }"
  >
    <!-- Empty State -->
    @if ( totalRowCount === 0 && !viewControl.closeEmptyMessages ) {
    <div class="documents-empty">
      <div class="documents-empty__card">
        <div class="documents-empty__icon">
          <i class="pi pi-folder-open"></i>
        </div>
        <h4>No documents found</h4>
        <p>There are no documents available in this library yet.</p>
      </div>
    </div>
    }

    <!-- Router Content -->
    <div class="documents-router">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
